import { BaseGenerator } from '../core/BaseGenerator.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * NRIC generator following Single Responsibility Principle
 */
export class NricGenerator extends BaseGenerator {
  generate(options = {}) {
    const { prefix = null, birthYear = null } = options;
    
    const prefixes = ['S', 'T'];
    const selectedPrefix = prefix || prefixes[this.randomInt(0, prefixes.length - 1)];
    
    let digits;
    if (birthYear) {
      const yearDigits = birthYear.toString().slice(-2);
      digits = yearDigits + this.randomDigits(5);
    } else {
      digits = this.randomDigits(7);
    }
    
    const partial = selectedPrefix + digits;
    const checksum = ChecksumCalculator.calculateNricChecksum(partial + 'A');
    
    return partial + checksum;
  }
}